import { setSelectors, addListeners, formatMoney } from './utilities.js';
import { request } from '@umbrella/cart-service';

class RcShippingBarWidget extends HTMLElement {
  
  constructor() {
    super();
    this.events = {};
    this._isUpdating = false;
    this.selectors = {};
    this.thresholdCents = 0;
    this.template = '';
    this.qualifyingText = '';
    this._onCartSignal = this._onCartSignal.bind(this);
  };

  connectedCallback() { this.initialize(); };

  disconnectedCallback() { this.deinitialize(); };

  _onCartSignal(event) { this._refreshFromCart(); };

  async _refreshFromCart(){
    if(this._isUpdating || !this.selectors.text || !this.selectors.progress || !this.thresholdCents) return;
    this._isUpdating = true;
    try {
      const cart = await request('/cart.js');
      const total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
      const threshold = this.thresholdCents;
      const remainingRaw = Math.max(threshold - total, 0);
      const ratioRaw = threshold > 0 ? (total * 100) / threshold : 0;
      const ratio = Math.max(0, Math.min(100, Math.round(ratioRaw)));
      this.selectors.progress.style.width = `${ratio}%`;
      this.selectors.start.textContent = formatMoney(total);
      this.selectors.finish.textContent = formatMoney(threshold);
      const labelEl = this.selectors.label;
      if(labelEl){
        // Opt-in (quick-cart variant): keep the remaining amount wrapped in a
        // denim <span> on live updates instead of flattening it to plain text.
        const highlightAmount = labelEl.dataset.highlightAmount === 'true';
        if(remainingRaw <= 0){
          const qualify = this.qualifyingText || labelEl.textContent || '';
          labelEl.textContent = qualify;
        } else {
          const formattedRemaining = formatMoney(remainingRaw);
          if(highlightAmount && this.template){
            labelEl.innerHTML = this.template.replace('%amount%', `<span class="qc-ship-amt">${formattedRemaining}</span>`);
          } else {
            const base = this.template || labelEl.textContent || '';
            labelEl.textContent = base.replace('%amount%', formattedRemaining);
          };
        };
      };
    } catch(err) {
      const U = window.umbrellaConfig || {};
      if(U && U.devMode) console.warn('rc-shipping-bar-widget: failed to update from cart', err);
    } finally {
      this._isUpdating = false;
    };
  };

  initialize() { 
    const U = window.umbrellaConfig || {};
    this.events = U.events || {};
    this.selectors = setSelectors(this, {
      text: '[data-shipping-bar-text]',
      label: '[data-shipping-bar-label]',
      progress: '[data-shipping-bar-progress]',
      start: '[data-shipping-bar-start]',
      finish: '[data-shipping-bar-finish]'
    });
    const textEl = this.selectors.text;
    if(textEl){
      const thresholdAttr = textEl.getAttribute('data-shipping-bar-threshold');
      this.thresholdCents = Number(thresholdAttr || 0) || 0;
      this.template = textEl.getAttribute('data-shipping-bar-msg') || '';
      this.qualifyingText = textEl.getAttribute('shipping-bar-qualifying-text') || '';
    };
    addListeners(document, {
      [this.events.cartChange]: this._onCartSignal,
      [this.events.cartAdded]: this._onCartSignal,
      [this.events.cartItemUpdated]: this._onCartSignal,
      [this.events.cartItemRemoved]: this._onCartSignal,
      [this.events.cartCleared]: this._onCartSignal,
      [this.events.quantityIncrement]: this._onCartSignal,
      [this.events.quantityDecrement]: this._onCartSignal
    });
  };
  
  deinitialize() { 
    const evs = this.events || {};
    const doc = document;
    if(evs.cartChange) doc.removeEventListener(evs.cartChange, this._onCartSignal);
    if(evs.cartAdded) doc.removeEventListener(evs.cartAdded, this._onCartSignal);
    if(evs.cartItemUpdated) doc.removeEventListener(evs.cartItemUpdated, this._onCartSignal);
    if(evs.cartItemRemoved) doc.removeEventListener(evs.cartItemRemoved, this._onCartSignal);
    if(evs.cartCleared) doc.removeEventListener(evs.cartCleared, this._onCartSignal);
  };

};

if(!customElements.get('rc-shipping-bar-widget')) customElements.define('rc-shipping-bar-widget', RcShippingBarWidget);